export default function Privacy() {
  return (
    <article className="legal card">
      <h1>Privacy Policy</h1>
      <p>
        <em>Startup Project Management</em> is operated by{" "}
        <strong>LineSpotting AB</strong>. Last updated 2026-08-05.
      </p>
      <p>
        This product is covered by the LineSpotting AB group privacy policy. Please read the full
        policy here:{" "}
        <a href="https://linespotting.com/privacy-policy/" target="_blank" rel="noreferrer">
          https://linespotting.com/privacy-policy/
        </a>
        .
      </p>
      <h2>1. Data we process in this app</h2>
      <p>
        Account email and name; workspace membership; profile photo; role titles; skill ratings;
        org seat placement; projects, tasks, comments, time entries; budget figures you enter;
        subscription entitlement status from app stores; technical logs (IP, device, errors).
      </p>
      <h2>2. Purpose</h2>
      <p>
        Provide the product, authenticate you, process payments via stores, secure the service, and
        improve reliability. We do not sell your personal data.
      </p>
      <h2>3. Hosting &amp; subprocessors</h2>
      <p>
        Infrastructure is primarily on Cloudflare (Pages, Workers, D1, R2). App stores process
        payments. Optional AI: if you enable xAI and paste an API key, prompts you initiate are sent
        to xAI under their terms — we do not store your API key on our servers.
      </p>
      <h2>4. Skill privacy</h2>
      <p>
        “Want to do” and “want to learn” ratings default to private to you; workspace settings may
        allow sharing with admins. Competence visibility follows workspace defaults.
      </p>
      <h2>5. Retention &amp; deletion</h2>
      <p>
        You may request export or deletion of workspace data (GDPR tools in-product as shipped).
        Backups may retain limited residual copies for a short period. See the group policy for
        retention detail.
      </p>
      <h2>6. Contact</h2>
      <p>
        LineSpotting AB — David Rad
        <br />
        Email:{" "}
        <a href="mailto:info@linespotting.com">info@linespotting.com</a>
        <br />
        Phone: +46 480 888 87
        <br />
        Web:{" "}
        <a href="https://linespotting.com/" target="_blank" rel="noreferrer">
          https://linespotting.com/
        </a>
      </p>
    </article>
  );
}
